import React, { forwardRef } from 'react';

import mergeClasses from '../../../utils/shallowMerge';
import defaultClasses from './ScrollBar.module.scss';

const CustomRangeInput = forwardRef((props, ref) => {
  const { step, setNewValue, newValue, blockRef, customClasses } = props;
  const styles = mergeClasses(defaultClasses, customClasses);

  return (
    <div className={styles.range}>
      <div className={styles.field}>
        <input
          ref={ref}
          onInput={(e) => {
            setNewValue(Number(e.target.value));
            // debugger
            if (blockRef && blockRef.current) {
              blockRef.current.scrollLeft =
                (e.target.value *
                  (blockRef?.current.children[0].offsetWidth -
                    blockRef?.current.offsetWidth)) /
                100;
            }
          }}
          type="range"
          min="0"
          max="100"
          value={newValue}
          step={step}
        />
      </div>
    </div>
  );
});

export default CustomRangeInput;
